export default __webpack_public_path__ + "static/media/steve_work_1.d80ff78a.png";